// Percorso file: src/utils/famiglia.js
//
// LA LETTURA DEI LEGAMI DI FAMIGLIA dal documento di persona, nel browser.
//
// ⚠️ SEDE UNICA (incarico G-K2). Fino a qui `idsDeiFigli` viveva in
// pages/home/HomeIncomplete.jsx (che la esportava a HomeParent,
// EnrolNextSeason, ClinicMember e Messaging) più una copia dichiarata,
// `idsDeiFigliCollegati`, in components/SystemView.jsx, che non poteva
// importarla da una pagina. Il corpo qui sotto è quello delle due, invariato.

// ⚠️ CRITERIO DI LETTURA DELL'ELENCO DEI FIGLI (rilievo §2 dell'incarico
// RL-7b). Nel frontend convivono due criteri divergenti sullo stesso campo:
// `lp.id || lp.profileId` in MemberProfileModal e il solo `lp.profileId`.
// Questa funzione ne usa UNO, quello TOLLERANTE:
//
//     id della voce = String(voce.profileId || voce.id || "").trim()
//
// Gli altri due criteri NON passano di qui: allinearli è una decisione, non
// una pulizia.
//
// Perché il tollerante: `profileId` è la grafia che scrivono OGGI tutte le
// rotte del backend (`POST /enrol-family` e `POST /register-child` in
// server.js, e la normalizzazione del `PUT /users/:id` in server.js, che
// accetta `profileId || id` ma riscrive sempre `profileId`); `id` è la grafia
// storica che può ancora giacere nei documenti vecchi. Leggere il solo
// `profileId` farebbe sparire dall'elenco un figlio di grafia antica — e un
// figlio che non compare è un figlio che non si può completare.
//
// ⚠️ IL LEGAME AUTOREVOLE È L'ALTRO: `guardians` sul documento del FIGLIO
// (server.js). È quello che apre lettura e scrittura, ed è quello su
// cui il server costruisce la cascata di famiglia. `linkedProfiles` è l'altra
// faccia, e qui si usa per un motivo solo: è l'UNICA sorgente che il frontend
// abbia: la query «i documenti che mi elencano fra i loro guardians» non ha
// rotta, e GET /users è riservata agli amministratori
// (`apiRouter.get('/users', requireAuth, soloAdminPerElenco, …)` in
// `backend/server.js` — citata per contenuto e non per numero di riga, che
// slitta a ogni fetta). Le due
// facce possono divergere, e la divergenza si vede — non si ripara (RL-7d):
//   • voce in `linkedProfiles` senza il legame di ritorno → la riga si mostra
//     in errore, perché GET /users/:id risponde 403;
//   • figlio con `guardians` ma non elencato qui → NON compare, e il timbro
//     del genitore resta spento senza che l'elenco lo spieghi. È il caso che
//     l'avviso in coda alla lista manda in segreteria.
// Nessun filtro sul `type` della voce: in questo modello ogni profilo
// collegato a un genitore è un figlio, e filtrare per una parola scritta da
// rotte diverse escluderebbe qualcuno per una grafia.
export function idsDeiFigli(genitore) {
  const voci =
    genitore && Array.isArray(genitore.linkedProfiles)
      ? genitore.linkedProfiles
      : [];

  const ids = [];

  for (const voce of voci) {
    if (!voce || typeof voce !== "object") continue;
    const id = String(voce.profileId || voce.id || "").trim();
    if (id && !ids.includes(id)) ids.push(id);
  }

  return ids;
}
